module.exports = __webpack_public_path__ + "img/shoping_bag.810f9a7b.svg";